import { render, staticRenderFns } from "./engagementCommentsTab.vue?vue&type=template&id=620c25c8&scoped=true&"
import script from "./engagementCommentsTab.vue?vue&type=script&lang=js&"
export * from "./engagementCommentsTab.vue?vue&type=script&lang=js&"
import style0 from "./engagementCommentsTab.vue?vue&type=style&index=0&id=620c25c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c25c8",
  null
  
)

export default component.exports